import { setContext } from 'apollo-link-context'
import { getHeaders } from '@/services/graphql/helpers'

export default setContext(getHeaders)
